export default __webpack_public_path__ + "static/media/menu1.646034a5.webp";